// // import React from 'react';

// // const SportsFitness = () => {
// //   const primaryColor = "rgb(0, 111, 47)";

// //   const indoorSports = ["Chess", "Carrom", "Table Tennis", "Martial Arts", "Yoga", "Aerobics"];
// //   const outdoorSports = ["Football", "Basketball", "Cricket", "Volleyball", "Skating", "Badminton", "Kabaddi"];

// //   return (
// //     <div style={{ paddingTop: "140px", backgroundColor: "#fff", minHeight: "100vh", fontFamily: "Segoe UI, sans-serif" }}>
      
// //       {/* 🖼️ DYNAMIC HERO BANNER */}
// //       <div style={{
// //         width: "100%",
// //         height: "300px",
// //         backgroundImage: 'linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url("https://images.unsplash.com/photo-1461896756913-c8b40e7220c4?auto=format&fit=crop&w=1350&q=80")', 
// //         backgroundSize: "cover",
// //         backgroundPosition: "center",
// //         display: "flex",
// //         flexDirection: "column",
// //         alignItems: "center",
// //         justifyContent: "center",
// //         color: "#fff",
// //         textAlign: "center",
// //         padding: "0 20px"
// //       }}>
// //         <h1 style={{ fontSize: "3rem", fontWeight: "800", marginBottom: "10px" }}>Healthy Body. Sharp Mind.</h1>
// //         <p style={{ fontSize: "1.5rem", fontWeight: "300" }}>"Champion Spirit in Every Child"</p>
// //       </div>

// //       <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "60px 20px" }}>
        
// //         {/* Intro Text */}
// //         <div style={{ textAlign: "center", marginBottom: "60px" }}>
// //           <p style={{ fontSize: "1.2rem", lineHeight: "1.8", color: "#444" }}>
// //             At DPS Kids, we believe in the ancient wisdom: <strong>a healthy mind resides in a healthy body.</strong><br />
// //             Our Sports & Fitness program goes far beyond PE class. Students are trained by qualified coaches in a wide range of indoor and outdoor sports, building not just physical strength, but discipline, teamwork, and mental resilience.
// //           </p>
// //         </div>

// //         {/* 🏆 SPORTS GRID SECTION */}
// //         <h2 style={{ textAlign: "center", color: primaryColor, marginBottom: "40px", fontSize: "2rem" }}>Sports We Offer</h2>
        
// //         <div style={{ 
// //           display: "grid", 
// //           gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", 
// //           gap: "30px",
// //           marginBottom: "80px" 
// //         }}>
          
// //           {/* Indoor Sports Card */}
// //           <div style={{
// //             background: "#f0f9f4",
// //             padding: "40px",
// //             borderRadius: "25px",
// //             boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
// //             borderBottom: `6px solid ${primaryColor}`
// //           }}>
// //             <h3 style={{ color: primaryColor, fontSize: "1.6rem", marginBottom: "20px", display: "flex", alignItems: "center", gap: "10px" }}>
// //               🏠 Indoor Sports
// //             </h3>
// //             <ul style={{ listStyle: "none", padding: 0 }}>
// //               {indoorSports.map((sport, i) => (
// //                 <li key={i} style={{ padding: "10px 0", borderBottom: "1px solid #ddd", fontWeight: "500", color: "#333" }}>
// //                   ✓ {sport}
// //                 </li>
// //               ))}
// //             </ul>
// //           </div>

// //           {/* Outdoor Sports Card */}
// //           <div style={{
// //             background: "#fff",
// //             padding: "40px",
// //             borderRadius: "25px",
// //             boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
// //             borderBottom: "6px solid #FFD700", // Gold color for outdoor
// //             border: "1px solid #eee"
// //           }}>
// //             <h3 style={{ color: "#b8860b", fontSize: "1.6rem", marginBottom: "20px", display: "flex", alignItems: "center", gap: "10px" }}>
// //               ☀️ Outdoor Sports
// //             </h3>
// //             <ul style={{ listStyle: "none", padding: 0 }}>
// //               {outdoorSports.map((sport, i) => (
// //                 <li key={i} style={{ padding: "10px 0", borderBottom: "1px solid #ddd", fontWeight: "500", color: "#333" }}>
// //                   ★ {sport}
// //                 </li>
// //               ))}
// //             </ul>
// //           </div>

// //         </div>

// //         {/* 🏅 ANNUAL SPORTS MEET SECTION */}
// //         <div style={{
// //           background: primaryColor,
// //           color: "#fff",
// //           padding: "50px",
// //           borderRadius: "30px",
// //           display: "flex",
// //           flexWrap: "wrap",
// //           alignItems: "center",
// //           gap: "40px",
// //           boxShadow: "0 15px 35px rgba(0, 111, 47, 0.3)"
// //         }}>
// //           <div style={{ flex: "1 1 400px" }}>
// //             <h2 style={{ fontSize: "2.2rem", marginBottom: "20px" }}>Annual Sports Meet</h2>
// //             <p style={{ fontSize: "1.1rem", lineHeight: "1.7", opacity: "0.9" }}>
// //               Every year, DPS Kids hosts its Annual Sports Meet — a vibrant celebration of athletic talent, team spirit, and healthy competition. 
// //               Students compete across age categories, cheered on by proud parents and enthusiastic peers. 
// //               Awards are presented to outstanding athletes, encouraging a culture of excellence and sportsmanship.
// //             </p>
// //           </div>
// //           <div style={{ 
// //             flex: "1 1 200px", 
// //             textAlign: "center", 
// //             background: "rgba(255,255,255,0.1)", 
// //             padding: "30px", 
// //             borderRadius: "20px",
// //             border: "2px dashed #fff" 
// //           }}>
// //             <span style={{ fontSize: "4rem" }}>🏆</span>
// //             <h4 style={{ marginTop: "10px" }}>Excellence In Sports</h4>
// //           </div>
// //         </div>

// //       </div>
// //     </div>
// //   );
// // };

// // export default SportsFitness;

// import React from "react";

// const SportsFitness = () => {
//   const primaryColor = "rgb(0, 111, 47)"; // Properly defined

//   const indoorSports = ["Chess", "Carrom", "Table Tennis", "Martial Arts", "Yoga", "Aerobics"];
//   const outdoorSports = ["Football", "Basketball", "Cricket", "Volleyball", "Skating", "Badminton", "Kabaddi"];

//   return (
//     <div style={styles.page}>
//       {/* TOP IMAGE HERO */}
//       <div style={styles.hero}>
//         <img
//           src="https://images.unsplash.com/photo-1461896756913-c8b40e7220c4?auto=format&fit=crop&w=1600&q=80"
//           alt="sports fitness"
//           style={styles.heroImage}
//         />
//         <div style={styles.heroOverlay} />
//         <div style={styles.heroContent}>
//           <h1 style={styles.heroTitle}>Healthy Body. Sharp Mind.</h1>
//           <p style={styles.heroSubtitle}>"Champion Spirit in Every Child"</p>
//         </div>
//       </div>

//       <div style={styles.section}>
//         <div style={styles.intro}>
//           <p style={styles.introText}>
//             At DPS Kids, we believe in the ancient wisdom: <strong>a healthy mind resides in a healthy body.</strong><br />
//             Our Sports & Fitness program goes far beyond PE class. Students are trained by qualified coaches in a wide range of indoor and outdoor sports, building not just physical strength, but discipline, teamwork, and mental resilience.
//           </p>
//         </div>

//         <h2 style={{
//           ...styles.heading,
//           color: primaryColor,
//         }}>Sports We Offer</h2>

//         <div style={styles.sportsGrid}>
//           <div className="sports-card" style={{
//             ...styles.indoorCard,
//             borderBottom: `6px solid ${primaryColor}`,
//           }}>
//             <h3 style={{
//               ...styles.sportsTitle,
//               color: primaryColor,
//             }}>
//               🏠 Indoor Sports
//             </h3>
//             <ul style={styles.sportsList}>
//               {indoorSports.map((sport, i) => (
//                 <li key={i} style={styles.sportsItem}>
//                   ✓ {sport}
//                 </li>
//               ))}
//             </ul>
//           </div>

//           <div className="sports-card" style={{
//             ...styles.outdoorCard,
//             borderBottom: "6px solid #FFD700",
//           }}>
//             <h3 style={{
//               ...styles.sportsTitle,
//               color: "#b8860b",
//             }}>
//               ☀️ Outdoor Sports
//             </h3>
//             <ul style={styles.sportsList}>
//               {outdoorSports.map((sport, i) => (
//                 <li key={i} style={styles.sportsItem}>
//                   ★ {sport}
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>

//         <div className="sports-meet" style={{
//           ...styles.sportsMeet,
//           background: primaryColor,
//           boxShadow: `0 15px 35px rgba(0, 111, 47, 0.3)`,
//         }}>
//           <div style={styles.meetLeft}>
//             <h2 style={styles.meetTitle}>Annual Sports Meet</h2>
//             <p style={styles.meetText}>
//               Every year, DPS Kids hosts its Annual Sports Meet — a vibrant celebration of athletic talent, team spirit, and healthy competition. 
//               Students compete across age categories, cheered on by proud parents and enthusiastic peers. 
//               Awards are presented to outstanding athletes, encouraging a culture of excellence and sportsmanship.
//             </p>
//           </div>
//           <div style={styles.meetRight}>
//             <span style={styles.trophyIcon}>🏆</span>
//             <h4 style={styles.trophyText}>Excellence In Sports</h4>
//           </div>
//         </div>
//       </div>

//       <style>{`
//         .sports-card {
//           transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//           will-change: transform;
//         }

//         .sports-card:hover {
//           transform: translateY(-12px);
//           box-shadow: 0 20px 40px rgba(0,0,0,0.15);
//         }

//         .sports-meet {
//           transition: transform 0.4s ease;
//         }

//         .sports-meet:hover {
//           transform: scale(1.02);
//         }

//         @media (max-width: 768px) {
//           .sports-grid {
//             grid-template-columns: 1fr !important;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default SportsFitness;

// const styles = {
//   page: {
//     paddingTop: "140px",
//     backgroundColor: "#fff",
//     minHeight: "100vh",
//     fontFamily: "Segoe UI, sans-serif",
//     overflowX: "hidden",
//   },
//   hero: {
//     position: "relative",
//     width: "100%",
//     height: "420px",
//     overflow: "hidden",
//   },
//   heroImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//     display: "block",
//   },
//   heroOverlay: {
//     position: "absolute",
//     inset: 0,
//     background: "rgba(0,0,0,0.45)",
//   },
//   heroContent: {
//     position: "absolute",
//     inset: 0,
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     textAlign: "center",
//     padding: "0 20px",
//     color: "#fff",
//   },
//   heroTitle: {
//     fontSize: "3rem",
//     fontWeight: "800",
//     marginBottom: "12px",
//   },
//   heroSubtitle: {
//     fontSize: "1.5rem",
//     fontWeight: "300",
//   },
//   section: {
//     maxWidth: "1100px",
//     margin: "0 auto",
//     padding: "60px 20px",
//   },
//   intro: {
//     textAlign: "center",
//     marginBottom: "60px",
//   },
//   introText: {
//     fontSize: "1.2rem",
//     lineHeight: "1.8",
//     color: "#444",
//   },
//   heading: {
//     textAlign: "center",
//     marginBottom: "40px",
//     fontSize: "2rem",
//   },
//   sportsGrid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//     gap: "30px",
//     marginBottom: "80px",
//   },
//   indoorCard: {
//     background: "#f0f9f4",
//     padding: "40px",
//     borderRadius: "25px",
//     boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
//   },
//   outdoorCard: {
//     background: "#fff",
//     padding: "40px",
//     borderRadius: "25px",
//     boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
//     border: "1px solid #eee",
//   },
//   sportsTitle: {
//     fontSize: "1.6rem",
//     marginBottom: "20px",
//     display: "flex",
//     alignItems: "center",
//     gap: "10px",
//   },
//   sportsList: {
//     listStyle: "none",
//     padding: 0,
//   },
//   sportsItem: {
//     padding: "10px 0",
//     borderBottom: "1px solid #ddd",
//     fontWeight: "500",
//     color: "#333",
//   },
//   sportsMeet: {
//     color: "#fff",
//     padding: "50px",
//     borderRadius: "30px",
//     display: "flex",
//     flexWrap: "wrap",
//     alignItems: "center",
//     gap: "40px",
//   },
//   meetLeft: {
//     flex: "1 1 400px",
//   },
//   meetTitle: {
//     fontSize: "2.2rem",
//     marginBottom: "20px",
//   },
//   meetText: {
//     fontSize: "1.1rem",
//     lineHeight: "1.7",
//     opacity: "0.9",
//   },
//   meetRight: {
//     flex: "1 1 200px",
//     textAlign: "center",
//     background: "rgba(255,255,255,0.1)",
//     padding: "30px",
//     borderRadius: "20px",
//     border: "2px dashed #fff",
//   },
//   trophyIcon: {
//     fontSize: "4rem",
//   },
//   trophyText: {
//     marginTop: "10px",
//   },
// };

// import React from "react";

// const SportsFitness = () => {
//   const primaryColor = "rgb(0, 111, 47)";

//   const indoorSports = ["Chess", "Carrom", "Table Tennis", "Martial Arts", "Yoga", "Aerobics"];
//   const outdoorSports = ["Football", "Basketball", "Cricket", "Volleyball", "Skating", "Badminton", "Kabaddi"];

//   return (
//     <div style={styles.page}>
//       {/* 🔥 TOP BANNER IMAGE - FULL WIDTH RESPONSIVE */}
//       <div style={styles.bannerHero}>
//         <img
//           src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=1920&q=85"
//           alt="DPS Kids Sports Fitness Banner"
//           style={styles.bannerImage}
//         />
//         <div style={styles.bannerOverlay} />
//         <div style={styles.bannerContent}>
//           <div style={styles.bannerBadge}>🏆 SPORTS EXCELLENCE</div>
//           <h1 style={styles.bannerTitle}>Healthy Body. Sharp Mind.</h1>
//           <p style={styles.bannerSubtitle}>"Champion Spirit in Every Child"</p>
//           <div style={styles.bannerStats}>
//             <div style={styles.statItem}>
//               <span style={styles.statNumber}>50+</span>
//               <span>Sports</span>
//             </div>
//             <div style={styles.statItem}>
//               <span style={styles.statNumber}>100%</span>
//               <span>Participation</span>
//             </div>
//             <div style={styles.statItem}>
//               <span style={styles.statNumber}>Annual</span>
//               <span>Meet</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* MAIN CONTENT */}
//       <div style={styles.section}>
//         <div style={styles.intro}>
//           <p style={styles.introText}>
//             At DPS Kids, we believe in the ancient wisdom: <strong>a healthy mind resides in a healthy body.</strong><br />
//             Our Sports & Fitness program goes far beyond PE class. Students are trained by qualified coaches in a wide range of indoor and outdoor sports, building not just physical strength, but discipline, teamwork, and mental resilience.
//           </p>
//         </div>

//         <h2 style={{
//           ...styles.heading,
//           color: primaryColor,
//         }}>Sports We Offer</h2>

//         <div style={styles.sportsGrid}>
//           <div className="sports-card" style={{
//             ...styles.indoorCard,
//             borderBottom: `6px solid ${primaryColor}`,
//           }}>
//             <h3 style={{
//               ...styles.sportsTitle,
//               color: primaryColor,
//             }}>
//               🏠 Indoor Sports
//             </h3>
//             <ul style={styles.sportsList}>
//               {indoorSports.map((sport, i) => (
//                 <li key={i} style={styles.sportsItem}>
//                   ✓ {sport}
//                 </li>
//               ))}
//             </ul>
//           </div>

//           <div className="sports-card" style={{
//             ...styles.outdoorCard,
//             borderBottom: "6px solid #FFD700",
//           }}>
//             <h3 style={{
//               ...styles.sportsTitle,
//               color: "#b8860b",
//             }}>
//               ☀️ Outdoor Sports
//             </h3>
//             <ul style={styles.sportsList}>
//               {outdoorSports.map((sport, i) => (
//                 <li key={i} style={styles.sportsItem}>
//                   ★ {sport}
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>

//         <div className="sports-meet" style={{
//           ...styles.sportsMeet,
//           background: primaryColor,
//           boxShadow: `0 15px 35px rgba(0, 111, 47, 0.3)`,
//         }}>
//           <div style={styles.meetLeft}>
//             <h2 style={styles.meetTitle}>Annual Sports Meet</h2>
//             <p style={styles.meetText}>
//               Every year, DPS Kids hosts its Annual Sports Meet — a vibrant celebration of athletic talent, team spirit, and healthy competition. 
//               Students compete across age categories, cheered on by proud parents and enthusiastic peers. 
//               Awards are presented to outstanding athletes, encouraging a culture of excellence and sportsmanship.
//             </p>
//           </div>
//           <div style={styles.meetRight}>
//             <span style={styles.trophyIcon}>🏆</span>
//             <h4 style={styles.trophyText}>Excellence In Sports</h4>
//           </div>
//         </div>
//       </div>

//       <style>{`
//         .sports-card {
//           transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//           will-change: transform;
//         }

//         .sports-card:hover {
//           transform: translateY(-12px);
//           box-shadow: 0 20px 40px rgba(0,0,0,0.15);
//         }

//         .sports-meet {
//           transition: transform 0.4s ease;
//         }

//         .sports-meet:hover {
//           transform: scale(1.02);
//         }

//         @media (max-width: 768px) {
//           .sports-grid {
//             grid-template-columns: 1fr !important;
//           }
//           .banner-stats {
//             flex-direction: column !important;
//             gap: 15px !important;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default SportsFitness;

// const styles = {
//   page: {
//     paddingTop: "0px", // Removed top padding for full banner
//     backgroundColor: "#fff",
//     minHeight: "100vh",
//     fontFamily: "Segoe UI, sans-serif",
//     overflowX: "hidden",
//   },
//   // 🔥 NEW BANNER STYLES
//   bannerHero: {
//     position: "relative",
//     width: "100%",
//     height: "500px",
//     overflow: "hidden",
//     marginBottom: "0",
//   },
//   bannerImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//     objectPosition: "center",
//     display: "block",
//     transition: "transform 0.6s ease",
//   },
//   bannerOverlay: {
//     position: "absolute",
//     inset: 0,
//     background: "linear-gradient(135deg, rgba(0,111,47,0.75) 0%, rgba(0,0,0,0.6) 100%)",
//     zIndex: 1,
//   },
//   bannerContent: {
//     position: "absolute",
//     inset: 0,
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     textAlign: "center",
//     padding: "0 30px",
//     zIndex: 2,
//     color: "#fff",
//   },
//   bannerBadge: {
//     background: "rgba(255,215,0,0.9)",
//     color: "#000",
//     padding: "8px 24px",
//     borderRadius: "50px",
//     fontSize: "0.9rem",
//     fontWeight: "700",
//     letterSpacing: "1px",
//     marginBottom: "20px",
//     boxShadow: "0 4px 15px rgba(255,215,0,0.4)",
//     animation: "pulse 2s infinite",
//   },
//   bannerTitle: {
//     fontSize: "clamp(2.2rem, 5vw, 4rem)",
//     fontWeight: "900",
//     marginBottom: "15px",
//     textShadow: "0 4px 20px rgba(0,0,0,0.5)",
//     letterSpacing: "-0.02em",
//     lineHeight: 1.1,
//   },
//   bannerSubtitle: {
//     fontSize: "clamp(1.2rem, 3vw, 1.8rem)",
//     fontWeight: "300",
//     marginBottom: "30px",
//     opacity: 0.95,
//     maxWidth: "600px",
//   },
//   bannerStats: {
//     display: "flex",
//     gap: "40px",
//     flexWrap: "wrap",
//     justifyContent: "center",
//   },
//   statItem: {
//     textAlign: "center",
//     minWidth: "80px",
//   },
//   statNumber: {
//     display: "block",
//     fontSize: "1.8rem",
//     fontWeight: "800",
//     color: "#FFD700",
//     textShadow: "0 2px 10px rgba(0,0,0,0.5)",
//   },
//   // ORIGINAL STYLES (unchanged)
//   section: {
//     maxWidth: "1100px",
//     margin: "0 auto",
//     padding: "60px 20px",
//   },
//   intro: {
//     textAlign: "center",
//     marginBottom: "60px",
//   },
//   introText: {
//     fontSize: "1.2rem",
//     lineHeight: "1.8",
//     color: "#444",
//   },
//   heading: {
//     textAlign: "center",
//     marginBottom: "40px",
//     fontSize: "2rem",
//   },
//   sportsGrid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
//     gap: "30px",
//     marginBottom: "80px",
//   },
//   indoorCard: {
//     background: "#f0f9f4",
//     padding: "40px",
//     borderRadius: "25px",
//     boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
//   },
//   outdoorCard: {
//     background: "#fff",
//     padding: "40px",
//     borderRadius: "25px",
//     boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
//     border: "1px solid #eee",
//   },
//   sportsTitle: {
//     fontSize: "1.6rem",
//     marginBottom: "20px",
//     display: "flex",
//     alignItems: "center",
//     gap: "10px",
//   },
//   sportsList: {
//     listStyle: "none",
//     padding: 0,
//   },
//   sportsItem: {
//     padding: "10px 0",
//     borderBottom: "1px solid #ddd",
//     fontWeight: "500",
//     color: "#333",
//   },
//   sportsMeet: {
//     color: "#fff",
//     padding: "50px",
//     borderRadius: "30px",
//     display: "flex",
//     flexWrap: "wrap",
//     alignItems: "center",
//     gap: "40px",
//   },
//   meetLeft: {
//     flex: "1 1 400px",
//   },
//   meetTitle: {
//     fontSize: "2.2rem",
//     marginBottom: "20px",
//   },
//   meetText: {
//     fontSize: "1.1rem",
//     lineHeight: "1.7",
//     opacity: "0.9",
//   },
//   meetRight: {
//     flex: "1 1 200px",
//     textAlign: "center",
//     background: "rgba(255,255,255,0.1)",
//     padding: "30px",
//     borderRadius: "20px",
//     border: "2px dashed #fff",
//   },
//   trophyIcon: {
//     fontSize: "4rem",
//   },
//   trophyText: {
//     marginTop: "10px",
//   },
// };


 import React, { useContext, useEffect, useState,style} from "react";
import { DataContext } from "../Screenss/DataContext";
const SportsFitness = () => {
  const primaryColor = "rgb(0, 111, 47)";
 const { data } = useContext(DataContext);
 const [current, setCurrent] = useState(0);
const galleryItems = data.filter(
    (item) => item.category === "sports"
  );

  // 🔁 Auto Slide
  useEffect(() => {
    if (galleryItems.length === 0) return;

    const interval = setInterval(() => {
      setCurrent((prev) =>
        prev === galleryItems.length - 1 ? 0 : prev + 1
      );
    }, 3000); // 3 sec

    return () => clearInterval(interval);
  }, [galleryItems]);

  const indoorSports = ["Chess", "Carrom", "Table Tennis", "Martial Arts", "Yoga", "Aerobics"];
  const outdoorSports = ["Football", "Basketball", "Cricket", "Volleyball", "Skating", "Badminton", "Kabaddi"];

  return (
    <div style={styles.page}>
      {/* 🔥 TOP BANNER */}
      {/* <div style={styles.bannerHero}>
        <img
          src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=1920&q=85"
          alt="Sports Fitness Banner"
          style={styles.bannerImage}
        />
        <div style={styles.bannerOverlay} />
        <div style={styles.bannerContent}>
          <div style={styles.bannerBadge}>🏆 SPORTS EXCELLENCE</div>
          <h1 style={styles.bannerTitle}>Healthy Body. Sharp Mind.</h1>
          <p style={styles.bannerSubtitle}>"Champion Spirit in Every Child"</p>
        </div>
      </div> */}
  {/* ✅ HERO SLIDER */}
      <section style={styles.hero}>
        <div style={styles.heroImageWrap}>
          
          {galleryItems.length > 0 && (
            <img
              src={galleryItems[current].full_url}
              alt="school banner"
              style={styles.heroImage}
            />
          )}

          {/* <div style={styles.heroOverlay} /> */}

          {/* <div style={styles.heroContent}>
            <h1 style={styles.heroTitle}>
              Building Foundations That Last a Lifetime
            </h1>
            <p style={styles.heroText}>
              A school is more than walls and textbooks — it is where futures are shaped, values are rooted, and dreams take flight.
            </p>
          </div> */}

          {/* ✅ Dots Indicator */}
          <div style={styles.dots}>
            {galleryItems.map((_, i) => (
              <span
                key={i}
                onClick={() => setCurrent(i)}
                style={{
                  ...styles.dot,
                  backgroundColor:
                    current === i ? "rgb(0,111,47)" : "#fff",
                }}
              />
            ))}
          </div>

        </div>
      </section>
      <div style={styles.section}>
        {/* <div style={styles.intro}>
          <p style={styles.introText}>
            At DPS Kids, we believe in the ancient wisdom: <strong>a healthy mind resides in a healthy body.</strong>
          </p>
        </div> */}

        <h2 style={{ ...styles.heading, color: primaryColor }}>Sports We Offer</h2>

        <div style={styles.sportsGrid}>
          {/* 🏠 INDOOR SPORTS CARD */}
          <div style={{ ...styles.sportsCard, borderTop: `6px solid ${primaryColor}` }}>
            <div style={styles.cardHeader}>
              <span style={styles.cardIcon}>🏠</span>
              <h3 style={{ ...styles.sportsTitle, color: primaryColor }}>Indoor Sports</h3>
            </div>
            <ul style={styles.sportsList}>
              {indoorSports.map((sport, i) => (
                <li key={i} className="sport-item" style={styles.sportsItem}>
                  <span className="check-icon" style={{ color: primaryColor, marginRight: "12px" }}>✓</span> 
                  {sport}
                </li>
              ))}
            </ul>
          </div>

          {/* ☀️ OUTDOOR SPORTS CARD */}
          <div style={{ ...styles.sportsCard, borderTop: "6px solid #FFD700" }}>
            <div style={styles.cardHeader}>
              <span style={styles.cardIcon}>☀️</span>
              <h3 style={{ ...styles.sportsTitle, color: "#b8860b" }}>Outdoor Sports</h3>
            </div>
            <ul style={styles.sportsList}>
              {outdoorSports.map((sport, i) => (
                <li key={i} className="sport-item" style={styles.sportsItem}>
                  <span className="check-icon" style={{ color: "#FFD700", marginRight: "12px" }}>★</span> 
                  {sport}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* ANNUAL SPORTS MEET */}
        <div style={{ ...styles.sportsMeet, background: primaryColor }}>
          <div style={styles.meetLeft}>
            <h2 style={styles.meetTitle}>Annual Sports Meet</h2>
            <p style={styles.meetText}>
              Every year, DPS Kids hosts its Annual Sports Meet — a vibrant celebration of athletic talent and team spirit.
            </p>
          </div>
          <div style={styles.meetRight}>
            <span style={styles.trophyIcon}>🏆</span>
            <h4 style={styles.trophyText}>Excellence In Sports</h4>
          </div>
        </div>
      </div>

      {/* 🔮 NEW CSS: Card Fixed, Items Floating */}
      <style>{`
        /* Card ko fixed rakha hai, move nahi karega */
        .sports-card {
          background: #fff;
        }

        /* Games ki list item par hover effect */
        .sport-item {
          transition: all 0.3s ease;
          cursor: pointer;
          position: relative;
          z-index: 1;
        }

        .sport-item:hover {
          transform: translateX(12px); /* Side mein thoda slide hoga */
          color: ${primaryColor};
          background: #f9f9f9;
          padding-left: 10px !important;
          font-weight: 700 !important;
          border-radius: 8px;
        }

        /* Check icon thoda "pop" karega */
        .sport-item:hover .check-icon {
          transform: scale(1.4);
          display: inline-block;
          transition: 0.2s;
        }

        @media (max-width: 768px) {
          .sports-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </div>
  );
};

export default SportsFitness;

// const styles = {
//   page: { backgroundColor: "#fcfcfc", minHeight: "100vh", fontFamily: "Segoe UI, sans-serif" },
//  hero: {
//     width: "100%",
//     marginTop: "120px",
//   },
//   heroImageWrap: {
//     position: "relative",
//     width: "100%",
//     height: "560px",
//     overflow: "hidden",
//     marginTop:140
//   },
//   heroImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//     display: "block",
//   },

//   //   bannerHero: { position: "relative", width: "100%", height: "420px", overflow: "hidden" },
// //   bannerImage: { width: "100%", height: "100%", objectFit: "cover" },
// //   bannerOverlay: { position: "absolute", inset: 0, background: "linear-gradient(rgba(0,111,47,0.6), rgba(0,0,0,0.7))" },
// //   bannerContent: { position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: "#fff" },
//   bannerBadge: { background: "#FFD700", color: "#000", padding: "8px 20px", borderRadius: "50px", fontWeight: "bold", marginBottom: "15px" },
//   bannerTitle: { fontSize: "3rem", fontWeight: "800", textAlign: "center" },
//   bannerSubtitle: { fontSize: "1.3rem", opacity: 0.9 },
  
//   section: { maxWidth: "1100px", margin: "0 auto", padding: "60px 20px" },
//   intro: { textAlign: "center", marginBottom: "50px" },
//   introText: { fontSize: "1.2rem", color: "#444", lineHeight: "1.8" },
//   heading: { textAlign: "center", marginBottom: "40px", fontSize: "2.5rem", fontWeight: "800" },
  
//   sportsGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "40px", marginBottom: "80px" },
//   sportsCard: { 
//     padding: "40px", 
//     borderRadius: "20px", 
//     boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "flex-start" 
//   },
//   cardHeader: { display: "flex", alignItems: "center", gap: "15px", marginBottom: "25px", borderBottom: "1px solid #eee", width: "100%", paddingBottom: "15px" },
//   cardIcon: { fontSize: "2rem" },
//   sportsTitle: { fontSize: "1.8rem", fontWeight: "700", margin: 0 },
  
//   sportsList: { listStyle: "none", padding: 0, margin: 0, width: "100%" },
//   sportsItem: { 
//     padding: "15px 0", 
//     borderBottom: "1px solid #f0f0f0", 
//     fontSize: "1.1rem", 
//     color: "#555", 
//     fontWeight: "500",
//     display: "flex",
//     alignItems: "center",
//   },
  
//   sportsMeet: { color: "#fff", padding: "50px", borderRadius: "30px", display: "flex", alignItems: "center", gap: "40px" },
//   meetLeft: { flex: 2 },
//   meetTitle: { fontSize: "2.2rem", marginBottom: "15px" },
//   meetText: { fontSize: "1.1rem", opacity: 0.9 },
//   meetRight: { flex: 1, textAlign: "center", background: "rgba(255,255,255,0.1)", padding: "20px", borderRadius: "20px" },
//   trophyIcon: { fontSize: "4rem" },
//   trophyText: { fontWeight: "bold", marginTop: "10px" }
// };

const styles = {
  page: {
    backgroundColor: "#fcfcfc",
    minHeight: "100vh",
    fontFamily: "Segoe UI, sans-serif"
  },

  hero: {
    width: "100%",
    marginTop: "clamp(80px, 10vw, 120px)", // 🔥 responsive top space
  },

  heroImageWrap: {
    position: "relative",
    width: "100%",
    height: "clamp(250px, 50vw, 560px)", // 🔥 responsive height
    overflow: "hidden",
    marginTop: "clamp(80px, 10vw, 140px)"
  },

  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },

  bannerBadge: {
    background: "#FFD700",
    color: "#000",
    padding: "6px 16px",
    borderRadius: "50px",
    fontWeight: "bold",
    marginBottom: "12px",
    fontSize: "clamp(12px, 2vw, 14px)"
  },

  bannerTitle: {
    fontSize: "clamp(20px, 5vw, 48px)", // 🔥 responsive text
    fontWeight: "800",
    textAlign: "center"
  },

  bannerSubtitle: {
    fontSize: "clamp(14px, 2.5vw, 20px)",
    opacity: 0.9
  },

  section: {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "clamp(30px, 6vw, 60px) 15px"
  },

  intro: {
    textAlign: "center",
    marginBottom: "clamp(30px, 5vw, 50px)"
  },

  introText: {
    fontSize: "clamp(14px, 2vw, 18px)",
    color: "#444",
    lineHeight: "1.8"
  },

  heading: {
    textAlign: "center",
    marginBottom: "clamp(25px, 5vw, 40px)",
    fontSize: "clamp(20px, 4vw, 40px)",
    fontWeight: "800"
  },

  /* 🔥 GRID FIX (MOST IMPORTANT) */
  sportsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", // 🔥 responsive auto grid
    gap: "clamp(20px, 4vw, 40px)",
    marginBottom: "clamp(40px, 6vw, 80px)"
  },

  sportsCard: {
    padding: "clamp(20px, 4vw, 40px)",
    borderRadius: "20px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },

  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "20px",
    borderBottom: "1px solid #eee",
    width: "100%",
    paddingBottom: "12px",
    flexWrap: "wrap" // 🔥 mobile fix
  },

  cardIcon: {
    fontSize: "clamp(20px, 3vw, 30px)"
  },

  sportsTitle: {
    fontSize: "clamp(16px, 3vw, 26px)",
    fontWeight: "700",
    margin: 0
  },

  sportsList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    width: "100%"
  },

  sportsItem: {
    padding: "12px 0",
    borderBottom: "1px solid #f0f0f0",
    fontSize: "clamp(13px, 2vw, 17px)",
    color: "#555",
    fontWeight: "500",
    display: "flex",
    alignItems: "center"
  },

  /* 🔥 FINAL SECTION FIX */
  sportsMeet: {
    color: "#fff",
    padding: "clamp(25px, 5vw, 50px)",
    borderRadius: "30px",
    display: "flex",
    alignItems: "center",
    gap: "clamp(20px, 5vw, 40px)",
    flexWrap: "wrap" // 🔥 mobile stack
  },

  meetLeft: {
    flex: "1 1 300px"
  },

  meetTitle: {
    fontSize: "clamp(18px, 4vw, 32px)",
    marginBottom: "10px"
  },

  meetText: {
    fontSize: "clamp(14px, 2vw, 18px)",
    opacity: 0.9
  },

  meetRight: {
    flex: "1 1 200px",
    textAlign: "center",
    background: "rgba(255,255,255,0.1)",
    padding: "clamp(15px, 3vw, 20px)",
    borderRadius: "20px"
  },

  trophyIcon: {
    fontSize: "clamp(40px, 6vw, 70px)"
  },

  trophyText: {
    fontWeight: "bold",
    marginTop: "10px",
    fontSize: "clamp(14px, 2vw, 18px)"
  }
};